import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DetailsEntreprisesComponent } from './details-entreprises/details-entreprises.component';
import { ListeEntreprisesComponent } from './liste-entreprises/liste-entreprises.component';
import { OffreEntreprisesComponent } from './offre-entreprises/offre-entreprises/offre-entreprises.component';
import { ListeEntrepriseClientfinalComponent } from './liste-entreprises-clientfinal/liste-entreprise-clientfinal/liste-entreprise-clientfinal.component';
import { ContacterResponsableComponent } from './contacter-responsable/contacter-responsable/contacter-responsable.component';
import { clientFinalGuard } from '@core/guards/client-final.guard';
import { esnAbonneNonabonneeGuard } from '@core/guards/esn-abonne-nonabonnee.guard';

const routes: Routes = [
  {
    path:'list',
    component:ListeEntreprisesComponent,
    canActivate: [esnAbonneNonabonneeGuard.canActivate]
  },
  {
    path:'listclientfinal',
    component:ListeEntrepriseClientfinalComponent,
    canActivate: [clientFinalGuard.canActivate]
  },
  {
    path:'details-entreprise/:id',
    component:DetailsEntreprisesComponent
  },
  {
    path:'offre-entreprise',
    component:OffreEntreprisesComponent
  },
  {
    path:'contacter-responsable',
    component:ContacterResponsableComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EntreprisesRoutingModule { }
